var exports = {
  "I": "summaryContainer__6Iz7T9",
};

module.exports = exports;
